import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_PRESET_REQUEST = 'preset/GET_PRESET_REQUEST'
const GET_PRESET_SUCCESS = 'preset/GET_PRESET_SUCCESS'
const GET_PRESET_FAILURE = 'preset/GET_PRESET_FAILURE'

const CREATE_PRESET_REQUEST = 'preset/CREATE_PRESET_REQUEST'
const CREATE_PRESET_SUCCESS = 'preset/CREATE_PRESET_SUCCESS'
const CREATE_PRESET_FAILURE = 'preset/CREATE_PRESET_FAILURE'

const UPDATE_PRESET_REQUEST = 'preset/UPDATE_PRESET_REQUEST'
const UPDATE_PRESET_SUCCESS = 'preset/UPDATE_PRESET_SUCCESS'
const UPDATE_PRESET_FAILURE = 'preset/UPDATE_PRESET_FAILURE'

const DELETE_PRESET_REQUEST = 'preset/DELETE_PRESET_REQUEST'
const DELETE_PRESET_SUCCESS = 'preset/DELETE_PRESET_SUCCESS'
const DELETE_PRESET_FAILURE = 'preset/DELETE_PRESET_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  preset: [],
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRESET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_PRESET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        preset: action.payload
      }
    case GET_PRESET_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PRESET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PRESET_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PRESET_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PRESET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PRESET_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PRESET_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PRESET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PRESET_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PRESET_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }

}

// Action Creators
export const getPreset = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_PRESET_REQUEST
      })

      const response = await API.get(EndPoints.PRESET + `/groupByCategory`)
      dispatch({
        type: GET_PRESET_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_PRESET_FAILURE
      })
    }
  }
}
export const createPreset = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_PRESET_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.PRESET + `/createPreset`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_PRESET_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PRESET_FAILURE
      })
    }
  }
}
export const updatePreset = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PRESET_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PRESET + `/updatePreset`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_PRESET_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PRESET_FAILURE
      })
    }
  }
}
export const deletePreset = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PRESET_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.PRESET + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_PRESET_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PRESET_FAILURE
      })
    }
  }
}

